// Module
var code = "<div layout=\"column\"> <agreements-table-header></agreements-table-header> <agreements-table-row ng-repeat=\"agreement in $ctrl.agreements\" agreement=\"agreement\"></agreements-table-row> </div> ";
// Exports
export default code;